// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';
import { detectCardBrand } from '@tectonics/prs/card-brand';

export function validateAcceptVisaTerms(accept: boolean, cardNumber: string): ?UserInputValidationError {
  const brand = detectCardBrand(cardNumber);

  if (brand === 'visa' && !accept) {
    return { id: 'agreement' };
  }
}
